import { VaiVemBaseAPI } from "./vai-vem.base.api";
import {
  API_URL_SERVICE,
  API_URL_AUTH,
  API_DETRAN_URL,
  API_DETRAN_URL_LOGIN,
  API_DETRAN_LOGIN,
  API_DETRAN_SENHA,
  API_VAIVEM_ESTUDANTE_URL,
  VAIVEM_ESTUDANTE_CNPJ_HEADER,
  VAIVEM_ESTUDANTE_TOKEN_HEADER,
  VAIVEM_ESTUDANTE_AMBIENTE
} from '@/commons/config';
import FunctionsCommuns from "@/util/FunctionsCommuns";
import VaiVemAuthService from "@/services/vai-vem.auth.service";
import axios from "axios"
import {from} from "rxjs";


export class VaiVemAPI extends VaiVemBaseAPI<any>{
    private apiUrlAuth: string
    private apiUrlDetran: string
    private apiUrlDetranLogin: string
    private apiDetranLogin: string
    private apiDetranSenha: string
    private apiVaivemEstudante: string
    constructor(){
        super()
        this.apiUrl = `${API_URL_SERVICE}`
        this.apiUrlAuth = `${API_URL_AUTH}`
        this.apiUrlDetran = `${API_DETRAN_URL}`
        this.apiUrlDetranLogin = `${API_DETRAN_URL_LOGIN}`
        this.apiDetranLogin = `${API_DETRAN_LOGIN}`
        this.apiDetranSenha = `${API_DETRAN_SENHA}`
        this.apiVaivemEstudante = `${API_VAIVEM_ESTUDANTE_URL}/webhook/${VAIVEM_ESTUDANTE_AMBIENTE}/vaivemEstudante`
    }

    public customAxios = axios.create();

    public findByStudant(cpf: string, dataNascimento: string){
      return this.axios.post(`${this.apiVaivemEstudante}/consultarEstudante`, {cpf: FunctionsCommuns.removeFormat(cpf), data_nascimento: FunctionsCommuns.formatDataBr(dataNascimento)});
    }

    public confirmReceipt(cpfAluno: string, idUsuario_entrega: string, nomeUsuario_entrega: string) {
      return this.axios.post(`${this.apiVaivemEstudante}/confirmarEntrega` ,
        {
            cpf: FunctionsCommuns.removeFormat(cpfAluno),
            id: idUsuario_entrega,
            nome: nomeUsuario_entrega
        },
        {
          headers: {
            "cnpj": VAIVEM_ESTUDANTE_CNPJ_HEADER,
            "token": VAIVEM_ESTUDANTE_TOKEN_HEADER
          }
        }
      )
    }

  public loginDetran(){
    return this.axios.post(`${this.apiUrlDetranLogin}`,{username: this.apiDetranLogin, password: this.apiDetranSenha})
  }
  public findByDesempregado(cpf: [], data_nascimento: string){
    return from( this.customAxios.post(`${this.apiUrlDetran}vaivem_user/get_user`,{cpf, data_nascimento},
      {headers: {
          Authorization: `Bearer ${VaiVemAuthService.tokenDetran}`,
          Accept: "application/json",
        }}
      ))
  }

  public confirmaEntregaDesempregado(cpf: string, data_entrega:string){
    return from( this.customAxios.post(`${this.apiUrlDetran}vaivem_user/confirma_entrega`,{cpf, data_entrega},
      {headers: {
          Authorization: `Bearer ${VaiVemAuthService.tokenDetran}`,
          Accept: "application/json",
        }}
    ))
  }

}
